// import isEmpty from 'lodash/isEmpty';

export const defaultField = {
    optin: true,
    secondary_optin: false,
    optin3: false,
    optin4: false,
    optin_id: 0,
    secondary_optin_id: 0,
    optin3_id: 0,
    optin4_id: 0,

    gender: "",
    zip: "",
    mobile: "",
//     parentConsentOn: "no",
    last_name: "",
    country: "",
    dob: "",
    first_name: "",
    email: "",
    age_group: "",
    name: "",

    requiredAge: 0,
    parentConsentAge: 0,
  
    location: {
        zip_code: "",
        latitude: 14.5053,
        longitude: 121.0181,
        country_name: "",
        country_code: "",
        state_name: "",
        timezone: "",
        state_code: "",
        city_name: "",
    },

    custom_fields: [],
    subscriptionWidgetId: "",
    calendarIds: [],
    icsFilename: "",

    device: "",
    os: "",
    application: "",
    fingerprint: "",
};


export function getOptins (optinValues) {
    function getValue (name) {
        const optin = optinValues[name];
        if (!optin) {
            return false;
        }
        return optin.value;
    }

    function getID (name) {
        const optin = optinValues[name];
          if (!optin) {
            return false;
        }
        return optin.id || 0;
    }
 
    const optins = {
        optin: getValue('Opt-in 1'),
        optin_id: getID('Opt-in 1'),

        secondary_optin: getValue('Opt-in 2'),
        secondary_optin_id: getID('Opt-in 2'),

        optin3: getValue('Opt-in 3'),
        optin3_id: getID('Opt-in 3'),

        optin4: getValue('Opt-in 4'),
        optin4_id: getID('Opt-in 4'),
    };

    return optins;
}

export function getCustomFields (customValues) {
    const customFields = [];
    for (let i in customValues) {
        customFields.push({
            name: i,
            value: customValues[i],
        });
    }
    return customFields;
}

export function getDeviceInfo (ua, flags) {
    const info = {
        application: `${ua.device.vendor}`.toLocaleLowerCase(),
        os: ua.os.name,
        device: flags.desktop ? 'Desktop' : 'mobile',
    };

    if (ua.ua.includes('iPad') || flags.tablet || flags?.model?.includes('iPad')) {
        info.device = 'tablet';
    }

    return info;
}

export function getFullName (first, last) {
    let name = '';
    if (first) {
        name = `${first}`;
    }

    if (last) {
        name =`${name} ${last}`;
    }
    return name;
}

export function removeEmptyFields (fields) {
    const params = {};
    const allowedEmpty = [
        'optin',
        'secondary_optin',
        'optin3',
        'optin4'
    ];

    for (let i in fields) {
        if (fields[i]) {
            params[i] = fields[i];
        }

        if (allowedEmpty.includes(i)) {
            params[i] = fields[i];
        }
    }
    return params;
}
